import * as React from "react";
import clsx from "clsx";
import { Database } from "lucide-react";
import { useCurrentSnapshotCitation } from "@/modules/snapshots/contexts/useCurrentSnapshotCitation";

interface Props {
  outcomeResultId: string;
  snapshotOutcomeId: string;
  startOffset?: number;
  endOffset?: number;
  onCitationClick?: () => void;
}

export const SnapshotCitationButton: React.FC<Props> = ({
  outcomeResultId,
  snapshotOutcomeId,
  startOffset,
  endOffset,
  onCitationClick,
}) => {
  const { currentSnapshotCitation, setCurrentSnapshotCitation } = useCurrentSnapshotCitation();
  const isActive = currentSnapshotCitation?.outcomeResultId === outcomeResultId;

  const handleClick = React.useCallback(() => {
    setCurrentSnapshotCitation({ outcomeResultId, snapshotOutcomeId, startOffset, endOffset });
    onCitationClick?.();
  }, [outcomeResultId, snapshotOutcomeId, startOffset, endOffset, setCurrentSnapshotCitation, onCitationClick]);

  return (
    <button
      type="button"
      onClick={handleClick}
      className={clsx(
        "mx-0.5 inline-flex items-center justify-center rounded border border-solid px-1 py-0.5 text-xs font-medium transition-colors duration-200",
        {
          "border-brand-gold-500 bg-brand-gold-100 text-brand-gold-800 hover:bg-brand-gold-200": isActive,
          "border-midnight-blue-900 bg-[#585451] text-white hover:bg-midnight-blue-800": !isActive,
        },
      )}
      aria-label="Snapshot citation"
    >
      <Database size={12} className={clsx({ "text-brand-gold-800": isActive, "text-white": !isActive })} />
    </button>
  );
};
